// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_loading-card__T8Xb3 {
  margin-bottom: 30px;
  padding: 15px 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}
@media only screen and (max-width: 480px) {
  .Loading_loading-card__T8Xb3 {
    box-shadow: none;
    border: 1px solid var(--light-grey);
  }
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/LoadingComponents/Loading.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;AACF;AAAE;EALF;IAMI,gBAAA;IACA,mCAAA;EAGF;AACF","sourcesContent":[".loading-card {\n  margin-bottom: 30px;\n  padding: 15px 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  @media only screen and (max-width: 480px) {\n    box-shadow: none;\n    border: 1px solid var(--light-grey);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-card": `Loading_loading-card__T8Xb3`
};
export default ___CSS_LOADER_EXPORT___;
